import Vue from 'vue';
import store from "./store";
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Vuelidate from "vuelidate";
import { IconsPlugin } from "bootstrap-vue";

// router setup
import router from './router/index.js';

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)

Vue.use(IconsPlugin);
Vue.use(DashboardPlugin);
Vue.use(Vuelidate);

/* eslint-disable no-new */
new Vue(
{
	el: '#app',
	render: h => h(App),
	router,
	store
});
